import { Component, OnInit } from '@angular/core';
import { LoginUnawareComponent } from '../../../../login-unaware-component';
import { DiagnosticsServiceFactory } from '../../../../services/diagnostics-service-factory';
import { DateHelperService } from '../../../../services/date-helper';
import { GraphClientService } from '../../../../services/graph-client-service';

const MAX_NUMBER_OF_ITEMS = 50;

/**
 *
 * */
@Component({
  selector: 'campfire-news-panel',
  templateUrl: './news-panel.component.html',
  styleUrls: ['./news-panel.component.scss']
})
export class NewsPanelComponent extends LoginUnawareComponent implements OnInit {
  public announcements: any[];
  public sourceHasMoreItems: boolean;
  public filteredCategory: string = null;
  public filteredTitle: string = null;

  constructor(diagnosticsFactory: DiagnosticsServiceFactory,
    private graphClient: GraphClientService,
    private dateHelper: DateHelperService) {
    super(diagnosticsFactory.create('NewsPanelComponent'));
    this.announcements = [];
  }

  ngOnInit(): void {
    this.graphClient.getData(this.constructor.name).subscribe(
      data => {
        const dynamicData = data as any;
        const allItems = dynamicData.value as any[];

        allItems.sort((left, right) => {
          let dl = new Date(left.createdDateTime).getTime();
          let dr = new Date(right.createdDateTime).getTime();

          return dr - dl;
        });

        this.announcements = allItems;

        //if (allItems.length > MAX_NUMBER_OF_ITEMS) {
        //  console.log(`${this.constructor.name}: WARNING: The number of items returned by data service exceeds the ` +
        //    `max. value of ${MAX_NUMBER_OF_ITEMS} items that can be displayed. The rest of the items are ignored.`);
        //  this.announcements = allItems.slice(0, MAX_NUMBER_OF_ITEMS);
        //  this.sourceHasMoreItems = true;
        //} else {
        //  this.announcements = allItems;
        //  this.sourceHasMoreItems = false;
        //}

        // Filter announcements that do not have a division specified.
        this.announcements = this.announcements.filter(a => !!a.fields.Division);
      }, error => {
        this.diagnostics.logError(`ERROR loading data. Details: ${JSON.stringify(error)}`);
      });
  }

  get categories(): string[] {
    return this.announcements
      .map(a => a.fields.Division)
      .reduce((prev: string[], current: string) => {
        if (!prev.find(p => p === current)) {
          prev.push(current);
        }

        return prev;
      }, [])
      .sort();
  }

  get filteredAnnouncements(): any[] {
    var filtered = this.announcements;

    if (this.filteredCategory) {
      filtered = filtered.filter(a => a.fields.Division === this.filteredCategory);
    }

    if (this.filteredTitle) {
      filtered = filtered.filter(a => a.fields.Title.toLowerCase().indexOf(this.filteredTitle.toLowerCase()) !== -1);
    }

    return filtered;
  }

  public getTimeline(item: any): string {
    const rawStart = item.fields.StartDate;
    const rawEnd = item.fields.EndDate;
    return this.dateHelper.getTimeline(rawStart, rawEnd);
  }

  onFilterSelected(category: string): void {
    if (this.filteredCategory === category) {
      this.filteredCategory = null;
    } else {
      this.filteredCategory = category;
    }
  }

  onSearchTextChange(event): void {
    if (!event.target.value) {
      this.filteredTitle = null;
    } else {
      this.filteredTitle = event.target.value;
    }
  }

  getFilteredCountForCategory(category): number {
    var filtered = this.announcements;

    // We can't use `filteredAnnouncements` because we want to keep the count of all categories,
    // not just the selected one. So only filter the title.

    if (this.filteredTitle) {
      filtered = filtered.filter(a => a.fields.Title.toLowerCase().indexOf(this.filteredTitle.toLowerCase()) !== -1);
    }

    return filtered.filter(a => a.fields.Division === category).length;
  }
}
